import { TypedDocumentNode, gql } from '@apollo/client';
import { FormattedMessage } from 'react-intl';

import { Tag } from '@sorare/core/src/atoms/ui/Tag';
import { playerUnavailability } from '@sorare/core/src/lib/glossary';

import { Status_PlayerInterface } from './__generated__/index.graphql';

type Props = {
  player: Status_PlayerInterface;
};

export const Status = ({ player }: Props) => {
  if (player.isActive) {
    return (
      <Tag small color="green">
        <FormattedMessage {...playerUnavailability.active} />
      </Tag>
    );
  }
  return (
    <Tag small color="red">
      <FormattedMessage {...playerUnavailability.inactive} />
    </Tag>
  );
};

Status.fragments = {
  PlayerInterface: gql`
    fragment Status_PlayerInterface on PlayerInterface {
      slug
      isActive
    }
  ` as TypedDocumentNode<Status_PlayerInterface>,
};
